module.exports = __webpack_public_path__ + "static/media/tabs-explorer-down.0b245bff.png";